   /*=========================================================================================
  File Name: state.js
  Description: Localization State
  ----------------------------------------------------------------------------------------
  Item Name: Localization State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    currency : 'kr',
    country : 'NO'
}